/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DocumentFetcherType } from "./DocumentFetcherType";
import {
  DocumentFetcherTypeFromJSON,
  DocumentFetcherTypeFromJSONTyped,
  DocumentFetcherTypeToJSON,
  DocumentFetcherTypeToJSONTyped,
} from "./DocumentFetcherType";
import type { DocumentType } from "./DocumentType";
import {
  DocumentTypeFromJSON,
  DocumentTypeFromJSONTyped,
  DocumentTypeToJSON,
  DocumentTypeToJSONTyped,
} from "./DocumentType";

/**
 *
 * @export
 * @interface DocumentFetcherDescription
 */
export interface DocumentFetcherDescription {
  /**
   *
   * @type {DocumentFetcherType}
   * @memberof DocumentFetcherDescription
   */
  type: DocumentFetcherType;
  /**
   *
   * @type {Array<DocumentType>}
   * @memberof DocumentFetcherDescription
   */
  availableDocuments: Array<DocumentType>;
  /**
   *
   * @type {string}
   * @memberof DocumentFetcherDescription
   */
  notes: string;
  /**
   *
   * @type {Array<string>}
   * @memberof DocumentFetcherDescription
   */
  unknownDocuments: Array<string>;
}

/**
 * Check if a given object implements the DocumentFetcherDescription interface.
 */
export function instanceOfDocumentFetcherDescription(
  value: object,
): value is DocumentFetcherDescription {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (
    !("availableDocuments" in value) ||
    value["availableDocuments"] === undefined
  )
    return false;
  if (!("notes" in value) || value["notes"] === undefined) return false;
  if (!("unknownDocuments" in value) || value["unknownDocuments"] === undefined)
    return false;
  return true;
}

export function DocumentFetcherDescriptionFromJSON(
  json: any,
): DocumentFetcherDescription {
  return DocumentFetcherDescriptionFromJSONTyped(json, false);
}

export function DocumentFetcherDescriptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentFetcherDescription {
  if (json == null) {
    return json;
  }
  return {
    type: DocumentFetcherTypeFromJSON(json["type"]),
    availableDocuments: (json["availableDocuments"] as Array<any>).map(
      DocumentTypeFromJSON,
    ),
    notes: json["notes"],
    unknownDocuments: json["unknownDocuments"],
  };
}

export function DocumentFetcherDescriptionToJSON(
  json: any,
): DocumentFetcherDescription {
  return DocumentFetcherDescriptionToJSONTyped(json, false);
}

export function DocumentFetcherDescriptionToJSONTyped(
  value?: DocumentFetcherDescription | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: DocumentFetcherTypeToJSON(value["type"]),
    availableDocuments: (value["availableDocuments"] as Array<any>).map(
      DocumentTypeToJSON,
    ),
    notes: value["notes"],
    unknownDocuments: value["unknownDocuments"],
  };
}
